import { render } from "./CreditsView.vue?vue&type=template&id=4c320b6e"
const script = {}

import "./CreditsView.vue?vue&type=style&index=0&id=4c320b6e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__